<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名 -->
    <div
      class="main"
      :class="{
        adjust: isSymbolAvailable,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- 俗名 -->
      <div class="secularNames">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`secularName-${column.order}`"
          class="secularName flex center column"
        >
          <!-- 俗名 -->
          <TabletCharacterImage
            v-for="(character, index) in column.secularName"
            :key="`character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />

          <!-- 位表記 -->
          <TabletCharacterImage
            v-for="(character, index) in underCharacters"
            :key="`under-character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...underCharactersPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>
      </div>
    </div>

    <!-- 没年月日 -->
    <div class="side">
      <div />
      <div class="dates">
        <!-- 左側: 没月 + 没日 + 没表記 -->
        <div class="date left flex align-center column justify-space-between">
           <!-- 没月 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].dateOfDeathMonth"
            :key="`deathMonth-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathMonthPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event,
            })"
          />

          <!-- 没日 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].dateOfDeathDay"
            :key="`deathDay-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathDayPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event,
            })"
          />

          <!-- 没表記 -->
          <TabletCharacterImage
            v-for="(character, index) in diedCharacter"
            :key="`diedCharacter-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...diedCharacterPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>

        <!-- 右側: 没年 -->
        <div class="date right flex align-center column justify-space-between">
           <!-- 没年 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].dateOfDeathYear"
            :key="`deathYear-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...dateOfDeathYearPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event,
            })"
          />
        </div>
      </div>
      <div />
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.front,
    TabletPreviewMixin.character,
  ],
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    // 梵字・家紋 + 戒名 + 位表記
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        isSymbolAvailable,
        columns,
        underCharacters,
      } = this;

      const defaultSize = 45;
      const maxHeight = !isSymbolAvailable ? 400 : 320 - 15;

      const characterLength = columns[0].secularName.length + underCharacters.length;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 没年月日 + 没表記
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideCharacterSize () {
      const { diedCharacter } = this;
      const {
        dateOfDeathYear,
        dateOfDeathMonth,
        dateOfDeathDay,
      } = this.columns[0];

      const defaultSize = 25;
      const maxHeight = 400;

      const rightCharacterLength = dateOfDeathYear.length;
      const leftCharacterLength = dateOfDeathMonth.length + dateOfDeathDay.length + diedCharacter.length;
      const characterLength = Math.max(rightCharacterLength, leftCharacterLength);
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    width: 50px;
    position: absolute;
    top: 0;
    left: -50px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      padding-bottom: 15px; // (80 - 50) / 2
    }

    @include symbol(100px);  // (150 + 50) / 2

    .secularNames {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularName {
        height: 100%;
        transform: translateX(100px);

        @include character(45px);
      }
    }
  }

  .side {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .dates {
      height: 100%;
      width: 100%;
      position: relative;

      .date {
        height: 100%;
        width: 50px;

        &.left {
          float: left;
        }

        &.right {
          float: right;
          transform: translateX(0px);
        }

        @include character(20px);
      }
    }
  }
}
</style>
